/**
 * Sample data for the ds/ catalog specimens.
 *
 * Its own module so the entry list and the stateful harnesses can both use it
 * without importing each other.
 */
export interface DemoRow {
  id: string;
  item: string;
  owner: string;
  altitude: number;
  score: number;
  state: 'on_track' | 'at_risk' | 'blocked';
}

export const ROWS: DemoRow[] = [
  { id: '1', item: 'Unify billing identity', owner: 'Nakamura', altitude: 2, score: 87, state: 'on_track' },
  { id: '2', item: 'Retire the legacy importer', owner: 'Okonkwo', altitude: 3, score: 74, state: 'at_risk' },
  { id: '3', item: 'Spell-check across surfaces', owner: 'Lindqvist', altitude: 4, score: 61, state: 'blocked' },
  { id: '4', item: 'Partner capability audit', owner: 'Abara', altitude: 2, score: 55, state: 'on_track' },
];

export const COLUMNS = [
  { key: 'item', header: 'Item', width: '40%' },
  { key: 'owner', header: 'Owner' },
  { key: 'altitude', header: 'Alt', numeric: true, width: '4rem' },
  { key: 'score', header: 'Score', numeric: true, sortable: true, width: '6rem' },
];

export const ACCENT = { on_track: 'green', at_risk: 'mustard', blocked: 'coral' } as const;

